var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.nullHidden)?_c('a',{staticClass:"saleBanner__link",attrs:{"href":_vm.saleBannerArray.link_url,"target":_vm.saleBannerArray.blank === 1 ? '_blank': ''}},[_c('img',{staticClass:"saleBanner__img",attrs:{"src":_vm.saleBannerArray.image_url}})]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1585a660","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/utvStore/components/SaleBanner.vue
// module id = null
// module chunks = 